// @flow

export const EMAIL = 'email'
